
(function () {
  'use strict';

  var CFG = window.__productTitleI18n || {};
  var dict = null;        // 词典：{ "rs228pu1": "标题译文", ... }（key 已归一化为小写 handle）
  var scheduled = [];     // 待扫描根节点
  var timer = null;

  /* 自动识别的已知渲染点标题元素（词典未收录的 handle 保持原文） */
  var SELECTORS = [
    '#ql-remomend-color-box .heading',              // recommended-products 推荐产品
    '[data-api-collection-handle] .product-block .title', // 带参的tab-collection产品卡
    '[data-usf-pid] .caption .title',              // 系列页/搜索页 网格卡标题
    // '[data-usf-pid] .usf-info-column .usf-title',  // 列表视图卡标题（备用）
    // 'a.product-title[href*="/products/"]',         // 即时搜索下拉「full 布局」卡标题
    // '[data-usf-pid] .ql-mb-size .header > span'    // 移动端快速加购弹层里的商品名
    '.pr-rv-container .product-block .title',        // recently-viewed 客户历史浏览产品列表
    ".usf-collections-page .product-item-meta__title",
    ".product-item-meta__title"
  ];
  /* 查询集 = 显式标记（data-translate-handle）+ 自动识别选择器 */
  var QUERY = '[data-translate-handle],' + SELECTORS.join(',');

  /* ---------- 语言检测：Liquid 注入（权威）→ html lang → URL 首段 ---------- */
  var locale = String(CFG.locale || document.documentElement.getAttribute('lang') || '').toLowerCase();
  if (!locale) {
    locale = String(location.pathname.split('/')[1] || '').toLowerCase();
  }
  /* 源语言 = 店铺默认语言（可能为德语、es-MX 等，不假定为英文）；Liquid 未下发时按 en 兜底 */
  var source = String(CFG.source || 'en').toLowerCase();
  if (!CFG.dictUrl || !locale || locale === source) return; // 默认语言页/未配置 → 静默停用

  /* ---------- handle 提取 ---------- */
  function handleFromUrl(href) {
    if (!href) return null;
    var m = String(href).match(/\/products\/([^\/?#]+)/);
    if (!m) return null;
    var h = m[1];
    try { h = decodeURIComponent(h); } catch (e) {}
    return h.toLowerCase();
  }

  /* 显式标记 data-translate-handle：值 = 商品 handle（优先使用）；属性留空 → 返回 null 走自动提取 */
  function markerHandle(el) {
    if (!el.getAttribute) return null;
    var v = String(el.getAttribute('data-translate-handle') || '').trim().toLowerCase();
    return v || null;
  }

  /* 从标题元素取 handle：优先最近的商品链接，其次卡片容器内第一个商品链接 */
  function handleFromEl(el) {
    var link = el.closest ? el.closest('a[href]') : null;
    var handle = link ? handleFromUrl(link.getAttribute('href')) : null;
    if (handle) return handle;
    var card = el.closest ? el.closest('[data-usf-pid]') : null;
    if (card) {
      var a = card.querySelector('a[href*="/products/"]');
      if (a) return handleFromUrl(a.getAttribute('href'));
    }
    return null;
  }

  /* ---------- 翻译：按 handle 查词典，整体替换标题文本 ---------- */
  function translateTitle(el) {
    if (!dict) return;
    var handle = markerHandle(el) || handleFromEl(el); // 属性值优先，留空则自动提取
    if (!handle) return;
    var to = dict[handle];
    if (!to) return; // 词典未收录 → 保持原文
    var current = (el.textContent || '').trim();
    if (!current || current === to) return; // 已一致（已翻译）→ 跳过，幂等防循环
    if (el.children.length) return; // 含子元素（如 <mark> 高亮结构）→ 不动，防破坏
    el.textContent = to;
  }

  function translateAll(root) {
    if (!dict) return;
    if (!root || root.nodeType !== 1) root = document.documentElement;
    if (root.matches && root.matches(QUERY)) translateTitle(root);
    var nodes = root.querySelectorAll(QUERY);
    for (var i = 0; i < nodes.length; i++) translateTitle(nodes[i]);
  }

  /* ---------- 动态内容：防抖增量扫描（usf 异步渲染/翻页/筛选/即时搜索/Vue 重渲染） ---------- */
  function schedule(node) {
    if (!node || node.nodeType !== 1) return;
    scheduled.push(node);
    if (timer) return;
    timer = setTimeout(function () {
      timer = null;
      var list = scheduled;
      scheduled = [];
      for (var i = 0; i < list.length; i++) translateAll(list[i]);
    }, 50);
  }

  function handleMutations(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'childList') {
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType === 1) schedule(n);
          else if (n.nodeType === 3 && n.parentElement) schedule(n.parentElement);
        }
      } else if (m.type === 'characterData' && m.target.parentElement) {
        schedule(m.target.parentElement);
      }
    }
  }

  /* ---------- 启动 ---------- */
  function bootstrap() {
    var req;
    try {
      req = window.fetch ? window.fetch(CFG.dictUrl, { credentials: 'omit' }) : null;
    } catch (e) {
      req = null;
    }
    if (!req || !req.then) return;
    req.then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    }).then(function (data) {
      if (!data || typeof data !== 'object' || Array.isArray(data)) return;
      /* 归一化：handle 去空白并转小写，译文去首尾空白；空值词条直接丢弃 */
      var map = Object.create(null);
      for (var key in data) {
        if (!Object.prototype.hasOwnProperty.call(data, key)) continue;
        var h = String(key).trim().toLowerCase();
        var to = data[key] == null ? '' : String(data[key]).trim();
        if (h && to) map[h] = to;
      }
      dict = map;
      translateAll(document.documentElement);
      if (typeof MutationObserver === 'function') {
        new MutationObserver(handleMutations).observe(document.documentElement, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
    })['catch'](function () {
      /* 词典缺失 / 网络异常 → 静默停用 */
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
